import type { WebViewerInstance } from "@pdftron/webviewer";

interface OpenIncludeAnnotationsModalParams {
  instance: WebViewerInstance;
  title: string;
  confirmText: string;
  dataElement: string;
  originalFileLabel: string;
  withAnnotationsLabel: string;
  onConfirm: (includeAnnotations: boolean) => Promise<void>;
}

/**
 * Create a modal using Apryse viewer capabilities for download or print.
 * @param param0 OpenIncludeAnnotationsModalParams
 * @returns void
 */
export const openIncludeAnnotationsModal = ({
  instance,
  title,
  confirmText,
  dataElement,
  originalFileLabel,
  withAnnotationsLabel,
  onConfirm,
}: OpenIncludeAnnotationsModalParams) => {
  const form = document.createElement("form");
  const container = document.createElement("div");
  container.className = "radio-button-container";
  form.appendChild(container);

  // option for original file
  const option1 = document.createElement("input");
  option1.type = "radio";
  option1.name = "includeAnnotationsOption";
  option1.value = "false";
  option1.id = `originalFile-${dataElement}`;
  const label1 = document.createElement("label");
  label1.htmlFor = option1.id;
  label1.className = "radio-label";
  label1.textContent = originalFileLabel;
  label1.insertBefore(option1, label1.firstChild);
  container.appendChild(label1);

  // option for PDF with annotations
  const option2 = document.createElement("input");
  option2.type = "radio";
  option2.name = "includeAnnotationsOption";
  option2.value = "true";
  option2.checked = true;
  option2.id = `pdfWithAnnotations-${dataElement}`;
  const label2 = document.createElement("label");
  label2.htmlFor = option2.id;
  label2.className = "radio-label";
  label2.textContent = withAnnotationsLabel;
  label2.insertBefore(option2, label2.firstChild);
  container.appendChild(label2);

  form.appendChild(container);

  const button = document.createElement("button");
  button.type = "submit";
  button.textContent = confirmText;
  button.className = "Button modal-button";
  form.appendChild(button);

  form.onsubmit = async (e) => {
    try {
      e.preventDefault();
      button.disabled = true;
      const formData = new FormData(form);
      const selectedOption = formData.get("includeAnnotationsOption");
      await onConfirm(selectedOption === "true");
      button.disabled = false;
      instance.UI.closeElements([dataElement]);
    } catch (error) {
      button.disabled = false;
      throw error;
    }
  };

  const closeButton = document.createElement("button");
  closeButton.className = "Button modal-close-button modular-ui icon-only";
  closeButton.ariaLabel = "Close";
  closeButton.type = "button";
  closeButton.ariaKeyShortcuts = "X";
  closeButton.innerHTML = `
    <div class="Icon " aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m0 0h24v24h-24z" fill="none"></path><path d="m19 6.41-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"></path>`;
  closeButton.onclick = () => {
    instance.UI.closeElements([dataElement]);
  };

  const modalOptions = {
    dataElement: dataElement,
    header: {
      title: title,
      className: "header-container",
      children: [closeButton],
    },
    render: () => {
      return null;
    },
    body: {
      children: [form],
    },
    footer: null,
  };

  instance.UI.addCustomModal(modalOptions);
  instance.UI.openElements([modalOptions.dataElement]);
};
